import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/ttmp',
    children: [
      {
        path: 'agreement',
        name: 'Agreement_ttmp',
        meta: {
          title: '用户协议',
          keepAlive: true,
        },
        component: () => import('@/views/ttmp/agreement.vue'),
      },
      {
        path: 'privacy',
        name: 'Privacy_ttmp',
        meta: {
          title: '隐私政策',
          keepAlive: true,
        },
        component: () => import('@/views/ttmp/privacy.vue'),
      },
      {
        path: 'enclosure',
        name: 'Enclosure_ttmp',
        meta: {
          title: '个人信息',
          keepAlive: true,
        },
        component: () => import('@/views/ttmp/enclosure.vue'),
      },
    ],
  },
]

export default routes
